export default __webpack_public_path__ + "static/media/Pickpocket's Belt of the Sundered Crown.d54aa8c9.jpg";